import { render } from "./ClearButton.vue?vue&type=template&id=b1323f56"
const script = {}
script.render = render

export default script